<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router.push(`/packages/${this.params.data.id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.name} (${this.params.data.packageType})"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch("product/deletePackage", this.params.data.id)
        .then((response)   => { this.showDeleteSuccess(response.data) })
        .catch(err => { console.warn(err)       })

    },
    showDeleteSuccess (data) {
      this.$vs.notify({
        color: 'success',
        title: 'Success',
        text: data.message
      })
    }
  }
}
</script>
